<template>
  <v-container class="mt-3">
    <v-row>
      <v-col cols="12" v-if="loading">
        <v-skeleton-loader type="article" class="mx-auto" />
      </v-col>
      <v-col cols="12" v-if="!canAccessProPanel && !loading">
        <v-alert type="info" outlined>
          <v-row align="center">
            <v-col class="grow">
              <span>You must be a PRO user to access this panel.</span>
            </v-col>
            <v-col class="shrink">
              <v-btn color="primary" to="/gopro">unlock with PRO</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col cols="12" v-if="canAccessProPanel && !loading">
        <v-row>
          <v-col cols="12">
            <v-alert type="info" outlined v-if="showWelcomeMsg">
              <v-row align="center">
                <v-col class="grow">
                  <span>
                    Welcome to the PRO panel! Go ahead and explore all the
                    premium features we offer.
                  </span>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="mb-2">
              <v-card-title class="text-h6 text--primary">
                Full review
              </v-card-title>
              <v-card-text>
                <p class="mb-3">
                  Check your resume against 20+ criteria including ATS
                  compatibility, formatting, and content quality. Get a detailed
                  analysis and suggestions for improvement.
                </p>
                <v-btn
                  color="#4caf50"
                  class="white--text"
                  to="/evaluate-ai?option=full"
                >
                  Start review
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="mb-2">
              <v-card-title class="text-h6 text--primary">
                Targeted review
              </v-card-title>
              <v-card-text>
                <p class="mb-3">
                  Verify how well your resume matches a specific job
                  description. Receive tailored feedback to enhance relevance
                  and impact.
                </p>
                <v-btn
                  color="#2196f3"
                  class="white--text"
                  to="/evaluate-ai?option=targeted"
                >
                  Start review
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-4">
          <v-card-title class="text-h6"> Recruitment process </v-card-title>
          <v-card-text>
            <v-row class="ma-0 pa-0">
              <v-col
                cols="12"
                md="6"
                lg="6"
                class="ma-0 pa-0 mb-5"
                v-for="company in recrutationProcess"
                :key="company.id"
              >
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="ma-0 pa-0 mb-2">
                    <div class="ma-0 pa-0">
                      <v-img
                        contain
                        :src="company.logo"
                        max-width="120"
                        class="mr-auto ml-0 pl-0"
                      ></v-img>
                    </div>
                  </v-col>
                  <v-col cols="12" class="ma-0 pa-0 mb-5">
                    <v-chip
                      small
                      outlined
                      class="mr-1 mb-2"
                      :to="`/recruitment-process?company=${company.id}&role=${role.id}`"
                      v-for="role in company.roles"
                      :key="role.id"
                      >{{ role.title }}</v-chip
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title class="text-h6">
            Latest articles from knowledge hub
          </v-card-title>
          <v-card-text>
            <v-list flat>
              <v-list-item-group v-model="selectedArticle">
                <v-list-item
                  v-for="article in latestArticles"
                  :key="article.id"
                  :to="article.url"
                >
                  <v-list-item-avatar>
                    <v-img :src="article.avatar" contain></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ article.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ article.excerpt }}
                    </v-list-item-subtitle>
                    <v-divider></v-divider>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-btn text>more articles</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedArticle: null,
      errorMsg: "",
      loading: true,
      activeSubscription: null,
      userIsPro: false,
      showWelcomeMsg: false,
      recrutationProcess: [
        {
          id: "goog",
          name: "Google",
          roles: [
            { title: "Software Engineer", id: "SWE" },
            { title: "Engineering Manager", id: "EM" },
            { title: "Technical Writer", id: "TW" },
          ],
          logo: require("../assets/goog-logo.jpg"),
        },
        {
          id: "meta",
          name: "Meta",
          roles: [
            { title: "Software Engineer", id: "SWE" },
            { title: "Engineering Manager", id: "EM" },
          ],
          logo: require("../assets/meta-logo.jpg"),
        },
        {
          id: "amzn",
          name: "Amazon",
          roles: [
            { title: "Software Engineer", id: "SWE" },
            { title: "Engineering Manager", id: "EM" },
          ],
          logo: require("../assets/amzn-logo.jpg"),
        },
        // {
        //   id: "appl",
        //   name: "Apple",
        //   roles: [
        //     { title: "Software Engineer", id: "SWE" },
        //     { title: "Design Lead", id: "DL" },
        //   ],
        //   logo: require("../assets/appl-logo.jpg"),
        // },
      ],
      latestArticles: [
        {
          id: 1,
          avatar: require("../assets/articles/art_optimize.jpg"),
          title: "How to Optimize Your Resume",
          excerpt: "Tips and tricks for making your resume stand out.",
          url: "/how-to-optimize-your-resume",
        },
        {
          id: 2,
          avatar: require("../assets/articles/art_tailoring.jpg"),
          title: "The Importance of Tailoring Your Resume",
          excerpt:
            "Why you should customize your resume for each job application.",
          url: "/the-importance-of-tailoring-your-resume",
        },
        {
          id: 3,
          avatar: require("../assets/articles/art_pitfalls.jpg"),
          title: "Common Resume Mistakes to Avoid",
          excerpt: "Pitfalls to watch out for when creating your resume.",
          url: "/common-resume-mistakes-to-avoid",
        },
      ],
    };
  },
  computed: {
    canAccessProPanel() {
      return this.userIsPro || this.$store.getters.hasProAccess;
    },
  },
  mounted() {
    this.$utils.visit(this);
    if (this.$route.query.welcome) {
      this.showWelcomeMsg = true;
    }
    this.getUserProStatus();
  },
  methods: {
    async getUserProStatus() {
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/getProStatus",
          {},
        );
        console.log("getUserProStatus resp: " + JSON.stringify(resp));
        this.userIsPro = resp.isPro;
        this.activeSubscription = resp.activeSubscription;
        this.$store.commit("setIsPro", this.userIsPro);
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
